import { combineReducers } from 'redux';
import habitatInsightsUploadReducer from 'src/app/habitat-insights/state/habitatInsightsUploadSlice';

export default combineReducers({
    habitatInsightsUpload: habitatInsightsUploadReducer,
});
